/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSpeedTest = /* GraphQL */ `
  query GetSpeedTest($id: ID!) {
    getSpeedTest(id: $id) {
      id
      createdAt
      updatedAt
      someData
      indexOne
      indexTwo
      indexThree
    }
  }
`;
export const listSpeedTests = /* GraphQL */ `
  query ListSpeedTests(
    $filter: ModelSpeedTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpeedTests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        someData
        indexOne
        indexTwo
        indexThree
      }
      nextToken
    }
  }
`;
export const getGlobalSpeedTest = /* GraphQL */ `
  query GetGlobalSpeedTest($id: ID!) {
    getGlobalSpeedTest(id: $id) {
      id
      createdAt
      updatedAt
      someData
      indexOne
      indexTwo
      indexThree
    }
  }
`;
export const listGlobalSpeedTests = /* GraphQL */ `
  query ListGlobalSpeedTests(
    $filter: ModelGlobalSpeedTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGlobalSpeedTests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        someData
        indexOne
        indexTwo
        indexThree
      }
      nextToken
    }
  }
`;
export const getQualityReportTemplates = /* GraphQL */ `
  query GetQualityReportTemplates($id: ID!) {
    getQualityReportTemplates(id: $id) {
      id
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      categories
      createdAt
      updatedAt
    }
  }
`;
export const listQualityReportTemplates = /* GraphQL */ `
  query ListQualityReportTemplates(
    $filter: ModelQualityReportTemplatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQualityReportTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        categories
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const speedTestByIndexOne = /* GraphQL */ `
  query SpeedTestByIndexOne(
    $indexOne: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpeedTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    speedTestByIndexOne(
      indexOne: $indexOne
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        someData
        indexOne
        indexTwo
        indexThree
      }
      nextToken
    }
  }
`;
export const speedTestByIndexTwo = /* GraphQL */ `
  query SpeedTestByIndexTwo(
    $indexTwo: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpeedTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    speedTestByIndexTwo(
      indexTwo: $indexTwo
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        someData
        indexOne
        indexTwo
        indexThree
      }
      nextToken
    }
  }
`;
export const speedTestByIndexThree = /* GraphQL */ `
  query SpeedTestByIndexThree(
    $indexThree: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpeedTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    speedTestByIndexThree(
      indexThree: $indexThree
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        someData
        indexOne
        indexTwo
        indexThree
      }
      nextToken
    }
  }
`;
export const globalSpeedTestByIndexOne = /* GraphQL */ `
  query GlobalSpeedTestByIndexOne(
    $indexOne: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGlobalSpeedTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    globalSpeedTestByIndexOne(
      indexOne: $indexOne
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        someData
        indexOne
        indexTwo
        indexThree
      }
      nextToken
    }
  }
`;
export const globalSpeedTestByIndexTwo = /* GraphQL */ `
  query GlobalSpeedTestByIndexTwo(
    $indexTwo: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGlobalSpeedTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    globalSpeedTestByIndexTwo(
      indexTwo: $indexTwo
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        someData
        indexOne
        indexTwo
        indexThree
      }
      nextToken
    }
  }
`;
export const globalSpeedTestByIndexThree = /* GraphQL */ `
  query GlobalSpeedTestByIndexThree(
    $indexThree: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGlobalSpeedTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    globalSpeedTestByIndexThree(
      indexThree: $indexThree
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        someData
        indexOne
        indexTwo
        indexThree
      }
      nextToken
    }
  }
`;
export const getCompanies = /* GraphQL */ `
  query GetCompanies($id: ID!) {
    getCompanies(id: $id) {
      id
      addresses {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      companyContactPersons {
        items {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        nextToken
      }
      visits {
        items {
          id
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          visitors
          address {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          participants
          hygiene
          environment
          purpose
          visitnumber
          additionalInformation
          countryCode
          date
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      number
      externalNumber
      name
      nameSearch
      type
      googleId
      size
      itemsID
      standardPaymentConditions
      paymentConditions
      standardDeliveryConditions
      standardVat
      users {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        nextToken
      }
      productRequests {
        items {
          id
          companiesID
          productRequestsID
          companies {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          productRequests {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          createdAt
          updatedAt
          contactPersonUserId
          countryCode
          involvedUsersIds
        }
        nextToken
      }
      priceOffers {
        items {
          id
          createdAt
          country
          price {
            currency
            value
          }
          currency
          additionalCosts {
            costs {
              currency
              value
            }
            type
          }
          productionTime
          currentPriceOffer
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          companiesID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          tiers {
            tierId
            price {
              currency
              value
            }
          }
          updatedAt
        }
        nextToken
      }
      countryCode
      closestPortUNCode
      websiteUrl
      vatNumber
      baseType
      exportCompanyId
      initialSetup
      productionCountryCode
      preferredCurrency
      communicationLanguage
      foundingDate
      companiesProductCategories {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          categoryId
          countryCode
          finalStage
          isAccepted
          createdAt
          updatedAt
        }
        nextToken
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByTypeByCompanyNameSearch = /* GraphQL */ `
  query CompaniesByTypeByCompanyNameSearch(
    $type: String!
    $nameSearch: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByTypeByCompanyNameSearch(
      type: $type
      nameSearch: $nameSearch
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByTypeByCompanyNumber = /* GraphQL */ `
  query CompaniesByTypeByCompanyNumber(
    $type: String!
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByTypeByCompanyNumber(
      type: $type
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByTypeByCreatedAt = /* GraphQL */ `
  query CompaniesByTypeByCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByTypeByCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByTypeByCountryCode = /* GraphQL */ `
  query CompaniesByTypeByCountryCode(
    $type: String!
    $countryCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByTypeByCountryCode(
      type: $type
      countryCode: $countryCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByTypeByContactPersonUserId = /* GraphQL */ `
  query CompaniesByTypeByContactPersonUserId(
    $type: String!
    $contactPersonUserId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByTypeByContactPersonUserId(
      type: $type
      contactPersonUserId: $contactPersonUserId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByTypeByCountryCodeByContactPersonUserId = /* GraphQL */ `
  query CompaniesByTypeByCountryCodeByContactPersonUserId(
    $type: String!
    $countryCodeContactPersonUserId: ModelCompaniesByTypeByContactPersonUserIdByCountryCodeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByTypeByCountryCodeByContactPersonUserId(
      type: $type
      countryCodeContactPersonUserId: $countryCodeContactPersonUserId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByCompanyNumber = /* GraphQL */ `
  query CompaniesByCompanyNumber(
    $baseType: String!
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByCompanyNumber(
      baseType: $baseType
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByCompanyNameSearch = /* GraphQL */ `
  query CompaniesByCompanyNameSearch(
    $baseType: String!
    $nameSearch: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByCompanyNameSearch(
      baseType: $baseType
      nameSearch: $nameSearch
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesByExportCompanyId = /* GraphQL */ `
  query CompaniesByExportCompanyId(
    $exportCompanyId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByExportCompanyId(
      exportCompanyId: $exportCompanyId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompaniesContactPersons = /* GraphQL */ `
  query GetCompaniesContactPersons($id: ID!) {
    getCompaniesContactPersons(id: $id) {
      id
      companyID
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      userID
      user {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      email
      firstName
      lastName
      mobil
      phone
      position
      countryCode
      createdAt
      updatedAt
    }
  }
`;
export const listCompaniesContactPersons = /* GraphQL */ `
  query ListCompaniesContactPersons(
    $filter: ModelCompaniesContactPersonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompaniesContactPersons(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesContactPersonsByEmail = /* GraphQL */ `
  query CompaniesContactPersonsByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesContactPersonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesContactPersonsByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompaniesProductCategories = /* GraphQL */ `
  query GetCompaniesProductCategories($id: ID!) {
    getCompaniesProductCategories(id: $id) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      categoryId
      countryCode
      finalStage
      isAccepted
      createdAt
      updatedAt
    }
  }
`;
export const listCompaniesProductCategories = /* GraphQL */ `
  query ListCompaniesProductCategories(
    $filter: ModelCompaniesProductCategoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompaniesProductCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        categoryId
        countryCode
        finalStage
        isAccepted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesProductCategoriesByCompany = /* GraphQL */ `
  query CompaniesProductCategoriesByCompany(
    $companyId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesProductCategoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesProductCategoriesByCompany(
      companyId: $companyId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        categoryId
        countryCode
        finalStage
        isAccepted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVisits = /* GraphQL */ `
  query GetVisits($id: ID!) {
    getVisits(id: $id) {
      id
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      visitors
      address {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      participants
      hygiene
      environment
      purpose
      visitnumber
      additionalInformation
      countryCode
      date
      createdAt
      updatedAt
    }
  }
`;
export const listVisits = /* GraphQL */ `
  query ListVisits(
    $filter: ModelVisitsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVisits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        visitors
        address {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        participants
        hygiene
        environment
        purpose
        visitnumber
        additionalInformation
        countryCode
        date
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustoms = /* GraphQL */ `
  query GetCustoms($id: ID!) {
    getCustoms(id: $id) {
      id
      currentCustomsStatus
      createdAt
      containerFreightCost {
        currency
        value
      }
      originCountry
      releaseDate
      positionNumber
      mrnNumber
      sentMrnNumber
      positions {
        hsCode
        itemDeclaration
        invoiceValue {
          currency
          value
        }
        tax {
          currency
          value
        }
        customsValue {
          currency
          value
        }
        iktValue {
          currency
          value
        }
        quantity
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
      }
      customsLocation
      weightNet {
        value
        unit
      }
      weightGross {
        value
        unit
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const listCustoms = /* GraphQL */ `
  query ListCustoms(
    $filter: ModelCustomsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustoms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        currentCustomsStatus
        createdAt
        containerFreightCost {
          currency
          value
        }
        originCountry
        releaseDate
        positionNumber
        mrnNumber
        sentMrnNumber
        positions {
          hsCode
          itemDeclaration
          invoiceValue {
            currency
            value
          }
          tax {
            currency
            value
          }
          customsValue {
            currency
            value
          }
          iktValue {
            currency
            value
          }
          quantity
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
        }
        customsLocation
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customsByReleaseDate = /* GraphQL */ `
  query CustomsByReleaseDate(
    $baseType: String!
    $releaseDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customsByReleaseDate(
      baseType: $baseType
      releaseDate: $releaseDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        currentCustomsStatus
        createdAt
        containerFreightCost {
          currency
          value
        }
        originCountry
        releaseDate
        positionNumber
        mrnNumber
        sentMrnNumber
        positions {
          hsCode
          itemDeclaration
          invoiceValue {
            currency
            value
          }
          tax {
            currency
            value
          }
          customsValue {
            currency
            value
          }
          iktValue {
            currency
            value
          }
          quantity
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
        }
        customsLocation
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customsByPositionNumber = /* GraphQL */ `
  query CustomsByPositionNumber(
    $baseType: String!
    $positionNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customsByPositionNumber(
      baseType: $baseType
      positionNumber: $positionNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        currentCustomsStatus
        createdAt
        containerFreightCost {
          currency
          value
        }
        originCountry
        releaseDate
        positionNumber
        mrnNumber
        sentMrnNumber
        positions {
          hsCode
          itemDeclaration
          invoiceValue {
            currency
            value
          }
          tax {
            currency
            value
          }
          customsValue {
            currency
            value
          }
          iktValue {
            currency
            value
          }
          quantity
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
        }
        customsLocation
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customsByMrnNumber = /* GraphQL */ `
  query CustomsByMrnNumber(
    $baseType: String!
    $mrnNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customsByMrnNumber(
      baseType: $baseType
      mrnNumber: $mrnNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        currentCustomsStatus
        createdAt
        containerFreightCost {
          currency
          value
        }
        originCountry
        releaseDate
        positionNumber
        mrnNumber
        sentMrnNumber
        positions {
          hsCode
          itemDeclaration
          invoiceValue {
            currency
            value
          }
          tax {
            currency
            value
          }
          customsValue {
            currency
            value
          }
          iktValue {
            currency
            value
          }
          quantity
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
        }
        customsLocation
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUsers = /* GraphQL */ `
  query GetUsers($id: ID!) {
    getUsers(id: $id) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      companyContactPersonUserId
      country
      contactPersonUserId
      email
      imageUrl
      lastLogin
      firstName
      lastName
      language
      mobil
      phone
      position
      notifications
      productTourStatus
      roleId
      role {
        id
        roleName
        type
        cognitoUserGroup
        permissions
        createdAt
        updatedAt
      }
      settings
      createdAt
      updatedAt
      countryCode
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      nextToken
    }
  }
`;
export const usersByCompanyId = /* GraphQL */ `
  query UsersByCompanyId(
    $companyId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByCompanyId(
      companyId: $companyId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      nextToken
    }
  }
`;
export const usersByEmail = /* GraphQL */ `
  query UsersByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      nextToken
    }
  }
`;
export const getContactPersons = /* GraphQL */ `
  query GetContactPersons($id: ID!) {
    getContactPersons(id: $id) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      hubspotId
      countries
      type
      funnel
      createdAt
      updatedAt
    }
  }
`;
export const listContactPersons = /* GraphQL */ `
  query ListContactPersons(
    $filter: ModelContactPersonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactPersons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const contactPersonsByType = /* GraphQL */ `
  query ContactPersonsByType(
    $type: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContactPersonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contactPersonsByType(
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const contactPersonsByFunnel = /* GraphQL */ `
  query ContactPersonsByFunnel(
    $funnel: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContactPersonsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contactPersonsByFunnel(
      funnel: $funnel
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserRoles = /* GraphQL */ `
  query GetUserRoles($id: ID!) {
    getUserRoles(id: $id) {
      id
      roleName
      type
      cognitoUserGroup
      permissions
      createdAt
      updatedAt
    }
  }
`;
export const listUserRoles = /* GraphQL */ `
  query ListUserRoles(
    $filter: ModelUserRolesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        roleName
        type
        cognitoUserGroup
        permissions
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const userRolesByType = /* GraphQL */ `
  query UserRolesByType(
    $type: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserRolesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userRolesByType(
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roleName
        type
        cognitoUserGroup
        permissions
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInvitations = /* GraphQL */ `
  query GetInvitations($id: ID!) {
    getInvitations(id: $id) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const listInvitations = /* GraphQL */ `
  query ListInvitations(
    $filter: ModelInvitationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvitations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyId
        createdAt
        email
        invitedByUserId
        invitedByUserName
        language
        roleId
        countryCode
        reminderStatus
        ttl
        updatedAt
      }
      nextToken
    }
  }
`;
export const invitationsByCompanyId = /* GraphQL */ `
  query InvitationsByCompanyId(
    $companyId: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvitationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invitationsByCompanyId(
      companyId: $companyId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        createdAt
        email
        invitedByUserId
        invitedByUserName
        language
        roleId
        countryCode
        reminderStatus
        ttl
        updatedAt
      }
      nextToken
    }
  }
`;
export const invitationsByReminderStatus = /* GraphQL */ `
  query InvitationsByReminderStatus(
    $reminderStatus: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvitationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invitationsByReminderStatus(
      reminderStatus: $reminderStatus
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        createdAt
        email
        invitedByUserId
        invitedByUserName
        language
        roleId
        countryCode
        reminderStatus
        ttl
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotifications = /* GraphQL */ `
  query GetNotifications($id: ID!) {
    getNotifications(id: $id) {
      createdAt
      updatedAt
      id
      userEmail
      title
      message
      userRead
      reference
      userId
      icon
      iconBackgroundColor
      type
      emailNotification
      ttl
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        updatedAt
        id
        userEmail
        title
        message
        userRead
        reference
        userId
        icon
        iconBackgroundColor
        type
        emailNotification
        ttl
      }
      nextToken
    }
  }
`;
export const notificationsByUser = /* GraphQL */ `
  query NotificationsByUser(
    $userId: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUser(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        updatedAt
        id
        userEmail
        title
        message
        userRead
        reference
        userId
        icon
        iconBackgroundColor
        type
        emailNotification
        ttl
      }
      nextToken
    }
  }
`;
export const getOrders = /* GraphQL */ `
  query GetOrders($id: ID!) {
    getOrders(id: $id) {
      id
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      createdAt
      orderDate
      cancelled
      companyId
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      currentOrderStatus
      customerReference
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      discount {
        currency
        value
      }
      freightCost {
        currency
        value
      }
      paymentConditions
      deliveryDate {
        actual
        allItemsSet
        planned
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      items {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      orderNumber
      orderStatusProcess {
        duration
        endAt
        name
        position
        startAt
      }
      sapCompanyName
      sapConfirmedDeliveryDate
      predictiveDeliveryDate
      sapCustomerNumber
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      createdByUserId
      purchaseOrder
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      baseType
      updatedAt
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByCompanyIdByOrderStatus = /* GraphQL */ `
  query OrdersByCompanyIdByOrderStatus(
    $companyId: String!
    $currentOrderStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByCompanyIdByOrderStatus(
      companyId: $companyId
      currentOrderStatus: $currentOrderStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByCompanyIdByOrderNumber = /* GraphQL */ `
  query OrdersByCompanyIdByOrderNumber(
    $companyId: String!
    $orderNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByCompanyIdByOrderNumber(
      companyId: $companyId
      orderNumber: $orderNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByCompanyIdByCustomerReference = /* GraphQL */ `
  query OrdersByCompanyIdByCustomerReference(
    $companyId: String!
    $customerReference: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByCompanyIdByCustomerReference(
      companyId: $companyId
      customerReference: $customerReference
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByCompanyIdBySapConfirmedDeliveryDate = /* GraphQL */ `
  query OrdersByCompanyIdBySapConfirmedDeliveryDate(
    $companyId: String!
    $sapConfirmedDeliveryDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByCompanyIdBySapConfirmedDeliveryDate(
      companyId: $companyId
      sapConfirmedDeliveryDate: $sapConfirmedDeliveryDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByContactPersonUserId = /* GraphQL */ `
  query OrdersByContactPersonUserId(
    $contactPersonUserId: ID!
    $currentOrderStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByContactPersonUserId(
      contactPersonUserId: $contactPersonUserId
      currentOrderStatus: $currentOrderStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByOrderNumberQuery = /* GraphQL */ `
  query OrdersByOrderNumberQuery(
    $orderNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByOrderNumberQuery(
      orderNumber: $orderNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByOrderNumber = /* GraphQL */ `
  query OrdersByOrderNumber(
    $baseType: String!
    $orderNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByOrderNumber(
      baseType: $baseType
      orderNumber: $orderNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByCustomerReference = /* GraphQL */ `
  query OrdersByCustomerReference(
    $baseType: String!
    $customerReference: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByCustomerReference(
      baseType: $baseType
      customerReference: $customerReference
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersByOrderStatus = /* GraphQL */ `
  query OrdersByOrderStatus(
    $baseType: String!
    $currentOrderStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByOrderStatus(
      baseType: $baseType
      currentOrderStatus: $currentOrderStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const ordersBySapConfirmedDeliveryDate = /* GraphQL */ `
  query OrdersBySapConfirmedDeliveryDate(
    $baseType: String!
    $sapConfirmedDeliveryDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersBySapConfirmedDeliveryDate(
      baseType: $baseType
      sapConfirmedDeliveryDate: $sapConfirmedDeliveryDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrderItems = /* GraphQL */ `
  query GetOrderItems($id: ID!) {
    getOrderItems(id: $id) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      deliveryDate
      orderDate
      currentOrderStatus
      customerItemNumber
      customerReference
      number
      quantity
      title
      price {
        currency
        value
      }
      ean
      weight {
        value
        unit
      }
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      hsCode
      volume {
        value
        unit
      }
      sapLineNumber
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      deliveries {
        items {
          id
          companyId
          deliveriesID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          comment
          deliveries {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
          ownerIds
        }
        nextToken
      }
      shipments {
        items {
          id
          companyId
          shipmentsID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      ordersID
      order {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      purchaseOrderItemsID
      manualPurchaseOrderItemsID
      purchaseOrderItemsM {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const listOrderItems = /* GraphQL */ `
  query ListOrderItems(
    $filter: ModelOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const orderItemsByNumberQuery = /* GraphQL */ `
  query OrderItemsByNumberQuery(
    $number: String!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderItemsByNumberQuery(
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShipments = /* GraphQL */ `
  query GetShipments($id: ID!) {
    getShipments(id: $id) {
      id
      size
      originCountry
      createdAt
      customsMrnNumber
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      freeText
      manualTracking
      trackingInformation
      positionNumber
      purchaseOrderItems {
        items {
          id
          shipmentsID
          purchaseOrderItemsID
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity
          comment
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      orderItems {
        items {
          id
          companyId
          shipmentsID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      deliveriesID
      delivery {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      carrier {
        name
        code
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      currentShipmentStatus
      type
      companyIds
      costs {
        currency
        value
      }
      etd
      eta
      position
      googleId
      telexReleaseStatus
      customsClearanceStatus
      trackingCode
      totalCargoWeight {
        value
        unit
      }
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      customsID
      customs {
        id
        currentCustomsStatus
        createdAt
        containerFreightCost {
          currency
          value
        }
        originCountry
        releaseDate
        positionNumber
        mrnNumber
        sentMrnNumber
        positions {
          hsCode
          itemDeclaration
          invoiceValue {
            currency
            value
          }
          tax {
            currency
            value
          }
          customsValue {
            currency
            value
          }
          iktValue {
            currency
            value
          }
          quantity
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
        }
        customsLocation
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      ownerIds
      baseType
      updatedAt
    }
  }
`;
export const listShipments = /* GraphQL */ `
  query ListShipments(
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShipments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentsByPositionNumber = /* GraphQL */ `
  query ShipmentsByPositionNumber(
    $baseType: String!
    $positionNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentsByPositionNumber(
      baseType: $baseType
      positionNumber: $positionNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentsByEtd = /* GraphQL */ `
  query ShipmentsByEtd(
    $baseType: String!
    $etd: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentsByEtd(
      baseType: $baseType
      etd: $etd
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentsByEta = /* GraphQL */ `
  query ShipmentsByEta(
    $baseType: String!
    $eta: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentsByEta(
      baseType: $baseType
      eta: $eta
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentsByStatus = /* GraphQL */ `
  query ShipmentsByStatus(
    $baseType: String!
    $currentShipmentStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentsByStatus(
      baseType: $baseType
      currentShipmentStatus: $currentShipmentStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const shpimentsByTelexReleaseStatus = /* GraphQL */ `
  query ShpimentsByTelexReleaseStatus(
    $baseType: String!
    $telexReleaseStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shpimentsByTelexReleaseStatus(
      baseType: $baseType
      telexReleaseStatus: $telexReleaseStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const shpimentsByCustomsClearanceStatus = /* GraphQL */ `
  query ShpimentsByCustomsClearanceStatus(
    $baseType: String!
    $customsClearanceStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shpimentsByCustomsClearanceStatus(
      baseType: $baseType
      customsClearanceStatus: $customsClearanceStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentsByCreatedAt = /* GraphQL */ `
  query ShipmentsByCreatedAt(
    $baseType: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentsByCreatedAt(
      baseType: $baseType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentsByTrackingCode = /* GraphQL */ `
  query ShipmentsByTrackingCode(
    $baseType: String!
    $trackingCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentsByTrackingCode(
      baseType: $baseType
      trackingCode: $trackingCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPurchaseOrders = /* GraphQL */ `
  query GetPurchaseOrders($id: ID!) {
    getPurchaseOrders(id: $id) {
      id
      createdAt
      cancelled
      country
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      currentPurchaseOrderStatus
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      finishedDate
      manufacturerContactPersonUserId
      manufacturerContactPerson {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      manufacturerAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      purchaseOrderNumber
      sapReference
      sapSupplierNumber
      sapSupplierCompanyName
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      discount {
        currency
        value
      }
      freightCost {
        currency
        value
      }
      paymentConditions
      title
      purchaseOrderStatusProcess {
        duration
        endAt
        name
        position
        startAt
      }
      salesConfirmationNumber
      items {
        items {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      googleId
      orderIdsGoogle
      baseType
      updatedAt
    }
  }
`;
export const listPurchaseOrders = /* GraphQL */ `
  query ListPurchaseOrders(
    $filter: ModelPurchaseOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPurchaseOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrdersByPurchaseOrderNumberQuery = /* GraphQL */ `
  query PurchaseOrdersByPurchaseOrderNumberQuery(
    $purchaseOrderNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByPurchaseOrderNumberQuery(
      purchaseOrderNumber: $purchaseOrderNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrdersByPurchaseOrderNumber = /* GraphQL */ `
  query PurchaseOrdersByPurchaseOrderNumber(
    $baseType: String!
    $purchaseOrderNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByPurchaseOrderNumber(
      baseType: $baseType
      purchaseOrderNumber: $purchaseOrderNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrdersByFinishedDate = /* GraphQL */ `
  query PurchaseOrdersByFinishedDate(
    $baseType: String!
    $finishedDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByFinishedDate(
      baseType: $baseType
      finishedDate: $finishedDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrdersByPurchaseOrderStatus = /* GraphQL */ `
  query PurchaseOrdersByPurchaseOrderStatus(
    $baseType: String!
    $currentPurchaseOrderStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByPurchaseOrderStatus(
      baseType: $baseType
      currentPurchaseOrderStatus: $currentPurchaseOrderStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrdersBySapReference = /* GraphQL */ `
  query PurchaseOrdersBySapReference(
    $baseType: String!
    $sapReference: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrdersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersBySapReference(
      baseType: $baseType
      sapReference: $sapReference
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPurchaseOrderItems = /* GraphQL */ `
  query GetPurchaseOrderItems($id: ID!) {
    getPurchaseOrderItems(id: $id) {
      id
      purchaseOrdersID
      purchaseOrder {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      createdAt
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      price {
        currency
        value
      }
      ean
      weight {
        value
        unit
      }
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      hsCode
      volume {
        value
        unit
      }
      sapLineNumber
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      orderNumberReference
      sapOrderLineNumberReference
      orderItems {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      orderItemsM {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          shipmentsID
          purchaseOrderItemsID
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity
          comment
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      qualityReports {
        items {
          id
          purchaseOrderItemsID
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          countries
          maxQuantityItemsToCheck
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          qualityReportItems {
            items {
              id
              countries
              qualityReportID
              testedItems
              createdAt
              updatedAt
            }
            nextToken
          }
          finalStatus
          finishedDate
          createdAt
          updatedAt
          baseType
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listPurchaseOrderItems = /* GraphQL */ `
  query ListPurchaseOrderItems(
    $filter: ModelPurchaseOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPurchaseOrderItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrderItemsByNumberQuery = /* GraphQL */ `
  query PurchaseOrderItemsByNumberQuery(
    $number: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrderItemsByNumberQuery(
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const purchaseOrdersByOrderNumberReferenceBySapOrderLineNumberReference = /* GraphQL */ `
  query PurchaseOrdersByOrderNumberReferenceBySapOrderLineNumberReference(
    $orderNumberReference: String!
    $sapOrderLineNumberReference: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    purchaseOrdersByOrderNumberReferenceBySapOrderLineNumberReference(
      orderNumberReference: $orderNumberReference
      sapOrderLineNumberReference: $sapOrderLineNumberReference
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDeliveriesOrderItems = /* GraphQL */ `
  query GetDeliveriesOrderItems($id: ID!) {
    getDeliveriesOrderItems(id: $id) {
      id
      companyId
      deliveriesID
      orderItemsID
      quantity
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      comment
      deliveries {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
      ownerIds
    }
  }
`;
export const listDeliveriesOrderItems = /* GraphQL */ `
  query ListDeliveriesOrderItems(
    $filter: ModelDeliveriesOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliveriesOrderItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        deliveriesID
        orderItemsID
        quantity
        packings {
          quantityInUnit
          quantity
          countedQuantity
          type
        }
        comment
        deliveries {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        createdAt
        updatedAt
        ownerIds
      }
      nextToken
    }
  }
`;
export const deliveryOrderItemsByDeliveries = /* GraphQL */ `
  query DeliveryOrderItemsByDeliveries(
    $deliveriesID: ID!
    $orderItemsID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveryOrderItemsByDeliveries(
      deliveriesID: $deliveriesID
      orderItemsID: $orderItemsID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        deliveriesID
        orderItemsID
        quantity
        packings {
          quantityInUnit
          quantity
          countedQuantity
          type
        }
        comment
        deliveries {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        createdAt
        updatedAt
        ownerIds
      }
      nextToken
    }
  }
`;
export const getShipmentsOrderItems = /* GraphQL */ `
  query GetShipmentsOrderItems($id: ID!) {
    getShipmentsOrderItems(id: $id) {
      id
      companyId
      shipmentsID
      orderItemsID
      quantity
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listShipmentsOrderItems = /* GraphQL */ `
  query ListShipmentsOrderItems(
    $filter: ModelShipmentsOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShipmentsOrderItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        shipmentsID
        orderItemsID
        quantity
        packings {
          quantityInUnit
          quantity
          countedQuantity
          type
        }
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentOrderItemsByShipments = /* GraphQL */ `
  query ShipmentOrderItemsByShipments(
    $shipmentsID: ID!
    $orderItemsID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentOrderItemsByShipments(
      shipmentsID: $shipmentsID
      orderItemsID: $orderItemsID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        shipmentsID
        orderItemsID
        quantity
        packings {
          quantityInUnit
          quantity
          countedQuantity
          type
        }
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShipmentsPurchaseOrderItems = /* GraphQL */ `
  query GetShipmentsPurchaseOrderItems($id: ID!) {
    getShipmentsPurchaseOrderItems(id: $id) {
      id
      shipmentsID
      purchaseOrderItemsID
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      quantity
      comment
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      createdAt
      updatedAt
    }
  }
`;
export const listShipmentsPurchaseOrderItems = /* GraphQL */ `
  query ListShipmentsPurchaseOrderItems(
    $filter: ModelShipmentsPurchaseOrderItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShipmentsPurchaseOrderItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shipmentsID
        purchaseOrderItemsID
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        quantity
        comment
        packings {
          quantityInUnit
          quantity
          countedQuantity
          type
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAnalytics = /* GraphQL */ `
  query GetAnalytics($id: ID!) {
    getAnalytics(id: $id) {
      id
      month
      year
      exchangeRates
      commodities
      createdAt
      updatedAt
    }
  }
`;
export const listAnalytics = /* GraphQL */ `
  query ListAnalytics(
    $filter: ModelAnalyticsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalytics(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        month
        year
        exchangeRates
        commodities
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const analyticsByYear = /* GraphQL */ `
  query AnalyticsByYear(
    $year: String!
    $month: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalyticsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analyticsByYear(
      year: $year
      month: $month
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        month
        year
        exchangeRates
        commodities
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDeliveries = /* GraphQL */ `
  query GetDeliveries($id: ID!) {
    getDeliveries(id: $id) {
      id
      createdAt
      size
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      trackingInformation
      positionNumber
      shipmentsID
      shipment {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        items {
          id
          companyId
          deliveriesID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          comment
          deliveries {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
          ownerIds
        }
        nextToken
      }
      carrier {
        name
        code
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      currentDeliveryStatus
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      type
      transportationType
      companyIds
      costs {
        currency
        value
      }
      etd
      eta
      distance
      position
      trackingCode
      googleId
      totalCargoWeight {
        value
        unit
      }
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      ownerIds
      baseType
      updatedAt
    }
  }
`;
export const listDeliveries = /* GraphQL */ `
  query ListDeliveries(
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliveries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const deliveriesByTypeByPositionNumber = /* GraphQL */ `
  query DeliveriesByTypeByPositionNumber(
    $type: String!
    $positionNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByTypeByPositionNumber(
      type: $type
      positionNumber: $positionNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const deliveriesByTypeByEta = /* GraphQL */ `
  query DeliveriesByTypeByEta(
    $type: String!
    $eta: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByTypeByEta(
      type: $type
      eta: $eta
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const deliveriesByTypeByEtaByCurrentDeliveryStatus = /* GraphQL */ `
  query DeliveriesByTypeByEtaByCurrentDeliveryStatus(
    $type: String!
    $etaCurrentDeliveryStatus: ModelDeliveriesByTypeByEtaByCurrentDeliveryStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByTypeByEtaByCurrentDeliveryStatus(
      type: $type
      etaCurrentDeliveryStatus: $etaCurrentDeliveryStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const deliveriesByTypeByStatus = /* GraphQL */ `
  query DeliveriesByTypeByStatus(
    $type: String!
    $currentDeliveryStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByTypeByStatus(
      type: $type
      currentDeliveryStatus: $currentDeliveryStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const deliveriesByPositionNumber = /* GraphQL */ `
  query DeliveriesByPositionNumber(
    $baseType: String!
    $positionNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByPositionNumber(
      baseType: $baseType
      positionNumber: $positionNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const deliveriesByEta = /* GraphQL */ `
  query DeliveriesByEta(
    $baseType: String!
    $eta: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByEta(
      baseType: $baseType
      eta: $eta
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const deliveriesByEtaByCurrentDeliveryStatus = /* GraphQL */ `
  query DeliveriesByEtaByCurrentDeliveryStatus(
    $baseType: String!
    $etaCurrentDeliveryStatus: ModelDeliveriesByEtaByCurrentDeliveryStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByEtaByCurrentDeliveryStatus(
      baseType: $baseType
      etaCurrentDeliveryStatus: $etaCurrentDeliveryStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const deliveriesByStatus = /* GraphQL */ `
  query DeliveriesByStatus(
    $baseType: String!
    $currentDeliveryStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByStatus(
      baseType: $baseType
      currentDeliveryStatus: $currentDeliveryStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDocuments = /* GraphQL */ `
  query GetDocuments($id: ID!) {
    getDocuments(id: $id) {
      id
      createdAt
      companyId
      companiesIDs
      collectionName
      storageKey
      type
      name
      fileType
      storageUrl
      countries
      country
      objectID
      updatedAt
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments(
    $filter: ModelDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        companyId
        companiesIDs
        collectionName
        storageKey
        type
        name
        fileType
        storageUrl
        countries
        country
        objectID
        updatedAt
      }
      nextToken
    }
  }
`;
export const documentsByObjectId = /* GraphQL */ `
  query DocumentsByObjectId(
    $objectID: ID!
    $collectionName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentsByObjectId(
      objectID: $objectID
      collectionName: $collectionName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        companyId
        companiesIDs
        collectionName
        storageKey
        type
        name
        fileType
        storageUrl
        countries
        country
        objectID
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompaniesAnalytics = /* GraphQL */ `
  query GetCompaniesAnalytics($id: ID!) {
    getCompaniesAnalytics(id: $id) {
      id
      year
      month
      createdAt
      quantityInvoices
      quantityOrders
      turnoverInvoices
      turnoverOrders
      productRequests
      customerRequests
      companyID
      updatedAt
    }
  }
`;
export const listCompaniesAnalytics = /* GraphQL */ `
  query ListCompaniesAnalytics(
    $filter: ModelCompaniesAnalyticsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompaniesAnalytics(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        year
        month
        createdAt
        quantityInvoices
        quantityOrders
        turnoverInvoices
        turnoverOrders
        productRequests
        customerRequests
        companyID
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesAnalyticsByYear = /* GraphQL */ `
  query CompaniesAnalyticsByYear(
    $year: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesAnalyticsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesAnalyticsByYear(
      year: $year
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        year
        month
        createdAt
        quantityInvoices
        quantityOrders
        turnoverInvoices
        turnoverOrders
        productRequests
        customerRequests
        companyID
        updatedAt
      }
      nextToken
    }
  }
`;
export const companiesAnalyticsByCompanyIdYear = /* GraphQL */ `
  query CompaniesAnalyticsByCompanyIdYear(
    $companyID: String!
    $year: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesAnalyticsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesAnalyticsByCompanyIdYear(
      companyID: $companyID
      year: $year
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        year
        month
        createdAt
        quantityInvoices
        quantityOrders
        turnoverInvoices
        turnoverOrders
        productRequests
        customerRequests
        companyID
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductRequests = /* GraphQL */ `
  query GetProductRequests($id: ID!) {
    getProductRequests(id: $id) {
      id
      createdAt
      channel
      customerRequestsID
      customerRequests {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      priority
      involvedUsersIds
      countries
      involvedUsers {
        userId
        firstName
        lastName
        email
        country
      }
      dueDate
      currentProductRequestStatus
      positionNumber
      sentOverdueReminder
      title
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      freeText
      customerCompanyID
      customerCompany {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      items {
        items {
          id
          productRequestsID
          itemsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          selectedPriceOffersId
          priceOffer
          priceOfferMoldCosts {
            currency
            value
          }
          productionTime
          deliveryType
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          targetPrice
          margin
          excludeAdditionalCosts
          containerSize
          airFreightCostsPerKilo
          transportCostWarehouseToCustomer
          workingCosts
          tiersId
          createdAt
          updatedAt
        }
        nextToken
      }
      companyIds {
        items {
          id
          companiesID
          productRequestsID
          companies {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          productRequests {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          createdAt
          updatedAt
          contactPersonUserId
          countryCode
          involvedUsersIds
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const listProductRequests = /* GraphQL */ `
  query ListProductRequests(
    $filter: ModelProductRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const productRequestsBySentOverdueReminder = /* GraphQL */ `
  query ProductRequestsBySentOverdueReminder(
    $sentOverdueReminder: String!
    $dueDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productRequestsBySentOverdueReminder(
      sentOverdueReminder: $sentOverdueReminder
      dueDate: $dueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const productRequestsByCustomerCompanyIdByStatus = /* GraphQL */ `
  query ProductRequestsByCustomerCompanyIdByStatus(
    $customerCompanyID: ID!
    $currentProductRequestStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productRequestsByCustomerCompanyIdByStatus(
      customerCompanyID: $customerCompanyID
      currentProductRequestStatus: $currentProductRequestStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const productRequestsByProductRequestStatus = /* GraphQL */ `
  query ProductRequestsByProductRequestStatus(
    $baseType: String!
    $currentProductRequestStatus: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productRequestsByProductRequestStatus(
      baseType: $baseType
      currentProductRequestStatus: $currentProductRequestStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const productRequestsByDueDate = /* GraphQL */ `
  query ProductRequestsByDueDate(
    $baseType: String!
    $dueDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productRequestsByDueDate(
      baseType: $baseType
      dueDate: $dueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const productRequestsByCreatedAt = /* GraphQL */ `
  query ProductRequestsByCreatedAt(
    $baseType: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productRequestsByCreatedAt(
      baseType: $baseType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const productRequestsByPositionNumber = /* GraphQL */ `
  query ProductRequestsByPositionNumber(
    $baseType: String!
    $positionNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productRequestsByPositionNumber(
      baseType: $baseType
      positionNumber: $positionNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getItems = /* GraphQL */ `
  query GetItems($id: ID!) {
    getItems(id: $id) {
      id
      companyIDs
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      customerArticleNumber
      title
      description
      number
      ean
      width {
        value
        unit
      }
      length {
        value
        unit
      }
      height {
        value
        unit
      }
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      active
      properties {
        propertyId
        name
        values
      }
      itemsHeadID
      itemsHead {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        customsRate
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        options {
          optionName
          optionValues
        }
        coverImageId
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        variants {
          items {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      variant {
        optionName
        optionValues
      }
      customsRate
      hsCode
      tariffCode
      duties {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      material
      coverImageId
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      packagings {
        type
        quantity
        weight {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        length {
          value
          unit
        }
        volume {
          value
          unit
        }
      }
      productRequests {
        items {
          id
          productRequestsID
          itemsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          selectedPriceOffersId
          priceOffer
          priceOfferMoldCosts {
            currency
            value
          }
          productionTime
          deliveryType
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          targetPrice
          margin
          excludeAdditionalCosts
          containerSize
          airFreightCostsPerKilo
          transportCostWarehouseToCustomer
          workingCosts
          tiersId
          createdAt
          updatedAt
        }
        nextToken
      }
      priceOffers {
        items {
          id
          createdAt
          country
          price {
            currency
            value
          }
          currency
          additionalCosts {
            costs {
              currency
              value
            }
            type
          }
          productionTime
          currentPriceOffer
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          companiesID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          tiers {
            tierId
            price {
              currency
              value
            }
          }
          updatedAt
        }
        nextToken
      }
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      priceScreenings {
        items {
          id
          createdAt
          ipAddress
          device
          browser
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          searchTerm
          priceCalculationMin
          priceCalculationMax
          salesPriceMin {
            currency
            value
          }
          salesPriceMax {
            currency
            value
          }
          items {
            title
            url
            price {
              currency
              value
            }
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      baseType
      categoryId
      qualityReportTemplates {
        items {
          id
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          categories
          createdAt
          updatedAt
        }
        nextToken
      }
      qualityReports {
        items {
          id
          purchaseOrderItemsID
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          countries
          maxQuantityItemsToCheck
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          qualityReportItems {
            items {
              id
              countries
              qualityReportID
              testedItems
              createdAt
              updatedAt
            }
            nextToken
          }
          finalStatus
          finishedDate
          createdAt
          updatedAt
          baseType
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listItems = /* GraphQL */ `
  query ListItems(
    $filter: ModelItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsByCompanyID = /* GraphQL */ `
  query ItemsByCompanyID(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByCompanyID(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsByCreatedAt = /* GraphQL */ `
  query ItemsByCreatedAt(
    $baseType: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByCreatedAt(
      baseType: $baseType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsByNumber = /* GraphQL */ `
  query ItemsByNumber(
    $baseType: String!
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByNumber(
      baseType: $baseType
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsByCustomerArticleNumber = /* GraphQL */ `
  query ItemsByCustomerArticleNumber(
    $baseType: String!
    $customerArticleNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByCustomerArticleNumber(
      baseType: $baseType
      customerArticleNumber: $customerArticleNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getItemsHead = /* GraphQL */ `
  query GetItemsHead($id: ID!) {
    getItemsHead(id: $id) {
      id
      companyIDs
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      hsCode
      tariffCode
      duties {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      material
      customsRate
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      options {
        optionName
        optionValues
      }
      coverImageId
      priceScreenings {
        items {
          id
          createdAt
          ipAddress
          device
          browser
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          searchTerm
          priceCalculationMin
          priceCalculationMax
          salesPriceMin {
            currency
            value
          }
          salesPriceMax {
            currency
            value
          }
          items {
            title
            url
            price {
              currency
              value
            }
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      variants {
        items {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const listItemsHeads = /* GraphQL */ `
  query ListItemsHeads(
    $filter: ModelItemsHeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItemsHeads(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        customsRate
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        options {
          optionName
          optionValues
        }
        coverImageId
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        variants {
          items {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsHeadByCompanyID = /* GraphQL */ `
  query ItemsHeadByCompanyID(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemsHeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsHeadByCompanyID(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        customsRate
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        options {
          optionName
          optionValues
        }
        coverImageId
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        variants {
          items {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsHeadByCreatedAt = /* GraphQL */ `
  query ItemsHeadByCreatedAt(
    $baseType: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemsHeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsHeadByCreatedAt(
      baseType: $baseType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        customsRate
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        options {
          optionName
          optionValues
        }
        coverImageId
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        variants {
          items {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getItemProperties = /* GraphQL */ `
  query GetItemProperties($id: ID!) {
    getItemProperties(id: $id) {
      id
      createdAt
      property
      values
      updatedAt
    }
  }
`;
export const listItemProperties = /* GraphQL */ `
  query ListItemProperties(
    $filter: ModelItemPropertiesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItemProperties(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        property
        values
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductRequestsItems = /* GraphQL */ `
  query GetProductRequestsItems($id: ID!) {
    getProductRequestsItems(id: $id) {
      id
      productRequestsID
      itemsID
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      selectedPriceOffersId
      priceOffer
      priceOfferMoldCosts {
        currency
        value
      }
      productionTime
      deliveryType
      quantity
      requestQuantity {
        value
        unit
      }
      minimumQuantity
      minimumOfferQuantity {
        value
        unit
      }
      targetPrice
      margin
      excludeAdditionalCosts
      containerSize
      airFreightCostsPerKilo
      transportCostWarehouseToCustomer
      workingCosts
      tiersId
      createdAt
      updatedAt
    }
  }
`;
export const listProductRequestsItems = /* GraphQL */ `
  query ListProductRequestsItems(
    $filter: ModelProductRequestsItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductRequestsItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productRequestsID
        itemsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        selectedPriceOffersId
        priceOffer
        priceOfferMoldCosts {
          currency
          value
        }
        productionTime
        deliveryType
        quantity
        requestQuantity {
          value
          unit
        }
        minimumQuantity
        minimumOfferQuantity {
          value
          unit
        }
        targetPrice
        margin
        excludeAdditionalCosts
        containerSize
        airFreightCostsPerKilo
        transportCostWarehouseToCustomer
        workingCosts
        tiersId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const productRequestItemsByItemsId = /* GraphQL */ `
  query ProductRequestItemsByItemsId(
    $itemsID: ID!
    $productRequestsID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductRequestsItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productRequestItemsByItemsId(
      itemsID: $itemsID
      productRequestsID: $productRequestsID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productRequestsID
        itemsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        selectedPriceOffersId
        priceOffer
        priceOfferMoldCosts {
          currency
          value
        }
        productionTime
        deliveryType
        quantity
        requestQuantity {
          value
          unit
        }
        minimumQuantity
        minimumOfferQuantity {
          value
          unit
        }
        targetPrice
        margin
        excludeAdditionalCosts
        containerSize
        airFreightCostsPerKilo
        transportCostWarehouseToCustomer
        workingCosts
        tiersId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPriceOffers = /* GraphQL */ `
  query GetPriceOffers($id: ID!) {
    getPriceOffers(id: $id) {
      id
      createdAt
      country
      price {
        currency
        value
      }
      currency
      additionalCosts {
        costs {
          currency
          value
        }
        type
      }
      productionTime
      currentPriceOffer
      quantity
      requestQuantity {
        value
        unit
      }
      minimumQuantity
      minimumOfferQuantity {
        value
        unit
      }
      companiesID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      tiers {
        tierId
        price {
          currency
          value
        }
      }
      updatedAt
    }
  }
`;
export const listPriceOffers = /* GraphQL */ `
  query ListPriceOffers(
    $filter: ModelPriceOffersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPriceOffers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        country
        price {
          currency
          value
        }
        currency
        additionalCosts {
          costs {
            currency
            value
          }
          type
        }
        productionTime
        currentPriceOffer
        quantity
        requestQuantity {
          value
          unit
        }
        minimumQuantity
        minimumOfferQuantity {
          value
          unit
        }
        companiesID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        tiers {
          tierId
          price {
            currency
            value
          }
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const priceOffersByCompany = /* GraphQL */ `
  query PriceOffersByCompany(
    $companiesID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPriceOffersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    priceOffersByCompany(
      companiesID: $companiesID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        country
        price {
          currency
          value
        }
        currency
        additionalCosts {
          costs {
            currency
            value
          }
          type
        }
        productionTime
        currentPriceOffer
        quantity
        requestQuantity {
          value
          unit
        }
        minimumQuantity
        minimumOfferQuantity {
          value
          unit
        }
        companiesID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        tiers {
          tierId
          price {
            currency
            value
          }
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const priceOffersCurrentPriceOfferByCompany = /* GraphQL */ `
  query PriceOffersCurrentPriceOfferByCompany(
    $companiesID: ID!
    $currentPriceOffer: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPriceOffersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    priceOffersCurrentPriceOfferByCompany(
      companiesID: $companiesID
      currentPriceOffer: $currentPriceOffer
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        country
        price {
          currency
          value
        }
        currency
        additionalCosts {
          costs {
            currency
            value
          }
          type
        }
        productionTime
        currentPriceOffer
        quantity
        requestQuantity {
          value
          unit
        }
        minimumQuantity
        minimumOfferQuantity {
          value
          unit
        }
        companiesID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        tiers {
          tierId
          price {
            currency
            value
          }
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const priceOffersByItems = /* GraphQL */ `
  query PriceOffersByItems(
    $itemsID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPriceOffersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    priceOffersByItems(
      itemsID: $itemsID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        country
        price {
          currency
          value
        }
        currency
        additionalCosts {
          costs {
            currency
            value
          }
          type
        }
        productionTime
        currentPriceOffer
        quantity
        requestQuantity {
          value
          unit
        }
        minimumQuantity
        minimumOfferQuantity {
          value
          unit
        }
        companiesID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        tiers {
          tierId
          price {
            currency
            value
          }
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const priceOffersByItemsByCurrentOffer = /* GraphQL */ `
  query PriceOffersByItemsByCurrentOffer(
    $itemsID: ID!
    $currentPriceOffer: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPriceOffersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    priceOffersByItemsByCurrentOffer(
      itemsID: $itemsID
      currentPriceOffer: $currentPriceOffer
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        country
        price {
          currency
          value
        }
        currency
        additionalCosts {
          costs {
            currency
            value
          }
          type
        }
        productionTime
        currentPriceOffer
        quantity
        requestQuantity {
          value
          unit
        }
        minimumQuantity
        minimumOfferQuantity {
          value
          unit
        }
        companiesID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        tiers {
          tierId
          price {
            currency
            value
          }
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const priceOffersByItemsByCurrentOfferByCompanyId = /* GraphQL */ `
  query PriceOffersByItemsByCurrentOfferByCompanyId(
    $itemsID: ID!
    $currentPriceOfferCompaniesID: ModelPriceOffersPriceOffersByItemsByCurrentOfferByCompanyIdCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPriceOffersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    priceOffersByItemsByCurrentOfferByCompanyId(
      itemsID: $itemsID
      currentPriceOfferCompaniesID: $currentPriceOfferCompaniesID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        country
        price {
          currency
          value
        }
        currency
        additionalCosts {
          costs {
            currency
            value
          }
          type
        }
        productionTime
        currentPriceOffer
        quantity
        requestQuantity {
          value
          unit
        }
        minimumQuantity
        minimumOfferQuantity {
          value
          unit
        }
        companiesID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        tiers {
          tierId
          price {
            currency
            value
          }
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFreightRates = /* GraphQL */ `
  query GetFreightRates($id: ID!) {
    getFreightRates(id: $id) {
      id
      createdAt
      containerSize
      from
      to
      rate {
        currency
        value
      }
      baseType
      updatedAt
    }
  }
`;
export const listFreightRates = /* GraphQL */ `
  query ListFreightRates(
    $filter: ModelFreightRatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFreightRates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        containerSize
        from
        to
        rate {
          currency
          value
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const freightRatesByFrom = /* GraphQL */ `
  query FreightRatesByFrom(
    $from: String!
    $to: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFreightRatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    freightRatesByFrom(
      from: $from
      to: $to
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        containerSize
        from
        to
        rate {
          currency
          value
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const freightRatesByFromByToByCreatedAt = /* GraphQL */ `
  query FreightRatesByFromByToByCreatedAt(
    $from: String!
    $toCreatedAt: ModelFreightRatesFreightRatesByFromByToByCreatedAtCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFreightRatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    freightRatesByFromByToByCreatedAt(
      from: $from
      toCreatedAt: $toCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        containerSize
        from
        to
        rate {
          currency
          value
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const freightRatesByCreatedAtByBaseType = /* GraphQL */ `
  query FreightRatesByCreatedAtByBaseType(
    $from: String!
    $createdAtBaseType: ModelFreightRatesByCreatedAtByBaseTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFreightRatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    freightRatesByCreatedAtByBaseType(
      from: $from
      createdAtBaseType: $createdAtBaseType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        containerSize
        from
        to
        rate {
          currency
          value
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const freightRatesByCreatedAt = /* GraphQL */ `
  query FreightRatesByCreatedAt(
    $baseType: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFreightRatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    freightRatesByCreatedAt(
      baseType: $baseType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        containerSize
        from
        to
        rate {
          currency
          value
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const freightRatesByCreatedAtByFrom = /* GraphQL */ `
  query FreightRatesByCreatedAtByFrom(
    $baseType: String!
    $createdAtFrom: ModelFreightRatesByCreatedAtByFromCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFreightRatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    freightRatesByCreatedAtByFrom(
      baseType: $baseType
      createdAtFrom: $createdAtFrom
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        containerSize
        from
        to
        rate {
          currency
          value
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTranslations = /* GraphQL */ `
  query GetTranslations($id: ID!) {
    getTranslations(id: $id) {
      id
      createdAt
      languageCode
      companyIDs
      field
      translation
      translationSearch
      collectionName
      objectID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      updatedAt
    }
  }
`;
export const listTranslations = /* GraphQL */ `
  query ListTranslations(
    $filter: ModelTranslationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTranslations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        languageCode
        companyIDs
        field
        translation
        translationSearch
        collectionName
        objectID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const translationsByCollectionNameByTranslation = /* GraphQL */ `
  query TranslationsByCollectionNameByTranslation(
    $collectionName: String!
    $translation: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTranslationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    translationsByCollectionNameByTranslation(
      collectionName: $collectionName
      translation: $translation
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        languageCode
        companyIDs
        field
        translation
        translationSearch
        collectionName
        objectID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const translationsByCollectionNameByTranslationSearch = /* GraphQL */ `
  query TranslationsByCollectionNameByTranslationSearch(
    $collectionName: String!
    $translationSearch: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTranslationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    translationsByCollectionNameByTranslationSearch(
      collectionName: $collectionName
      translationSearch: $translationSearch
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        languageCode
        companyIDs
        field
        translation
        translationSearch
        collectionName
        objectID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const translationsByObject = /* GraphQL */ `
  query TranslationsByObject(
    $objectID: ID!
    $languageCodeCollectionName: ModelTranslationsTranslationsByObjectCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTranslationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    translationsByObject(
      objectID: $objectID
      languageCodeCollectionName: $languageCodeCollectionName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        languageCode
        companyIDs
        field
        translation
        translationSearch
        collectionName
        objectID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPriceScreenings = /* GraphQL */ `
  query GetPriceScreenings($id: ID!) {
    getPriceScreenings(id: $id) {
      id
      createdAt
      ipAddress
      device
      browser
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      searchTerm
      priceCalculationMin
      priceCalculationMax
      salesPriceMin {
        currency
        value
      }
      salesPriceMax {
        currency
        value
      }
      items {
        title
        url
        price {
          currency
          value
        }
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const listPriceScreenings = /* GraphQL */ `
  query ListPriceScreenings(
    $filter: ModelPriceScreeningsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPriceScreenings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        ipAddress
        device
        browser
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        searchTerm
        priceCalculationMin
        priceCalculationMax
        salesPriceMin {
          currency
          value
        }
        salesPriceMax {
          currency
          value
        }
        items {
          title
          url
          price {
            currency
            value
          }
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const priceScreeningsByItems = /* GraphQL */ `
  query PriceScreeningsByItems(
    $itemsID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPriceScreeningsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    priceScreeningsByItems(
      itemsID: $itemsID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        ipAddress
        device
        browser
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        searchTerm
        priceCalculationMin
        priceCalculationMax
        salesPriceMin {
          currency
          value
        }
        salesPriceMax {
          currency
          value
        }
        items {
          title
          url
          price {
            currency
            value
          }
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomerRequests = /* GraphQL */ `
  query GetCustomerRequests($id: ID!) {
    getCustomerRequests(id: $id) {
      id
      createdAt
      currentStatus
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      customerContactPerson {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      notes
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      reference
      successfull
      hubspotDealId
      productRequestsID
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      salesOffers {
        items {
          id
          customerRequestID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          acceptedByUserID
          createdAt
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          contactPersonID
          decimalPlaces
          number
          productRequestsID
          paymentConditions
          deliveryConditions
          netSum {
            currency
            value
          }
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          deliveryTime
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          offerItems {
            items {
              id
              salesOffersID
              salesOffer {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              companyID
              createdAt
              title
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity {
                value
                unit
              }
              price {
                currency
                value
              }
              discount
              vat
              optional
              toolCosts {
                currency
                value
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              editable
              selected
              serviceTemplate
              updatedAt
            }
            nextToken
          }
          itemsSelectable
          deliveryCosts {
            currency
            value
          }
          deliveryVat
          declineReason
          declineComment
          internalComment
          externalComment
          customerReference
          status
          validUntil
          sentExpiringReminder
          updatedAt
        }
        nextToken
      }
      customerRequestItems {
        items {
          id
          createdAt
          companyID
          contactPersonID
          title
          description
          customerArticleNumber
          quantity {
            value
            unit
          }
          targetPrice {
            currency
            value
          }
          material
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          itemsID
          notes
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          customerRequestsID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        nextToken
      }
      messages {
        createdAt
        message
        sender
      }
      baseType
      updatedAt
    }
  }
`;
export const listCustomerRequests = /* GraphQL */ `
  query ListCustomerRequests(
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestsByContactPersonID = /* GraphQL */ `
  query CustomerRequestsByContactPersonID(
    $contactPersonID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByContactPersonID(
      contactPersonID: $contactPersonID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestsByComanyIdByCreatedAt = /* GraphQL */ `
  query CustomerRequestsByComanyIdByCreatedAt(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByComanyIdByCreatedAt(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestsByComanyIdByNumber = /* GraphQL */ `
  query CustomerRequestsByComanyIdByNumber(
    $companyID: ID!
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByComanyIdByNumber(
      companyID: $companyID
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestsByComanyIdByCurrentStatus = /* GraphQL */ `
  query CustomerRequestsByComanyIdByCurrentStatus(
    $companyID: ID!
    $currentStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByComanyIdByCurrentStatus(
      companyID: $companyID
      currentStatus: $currentStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestsByCreatedAt = /* GraphQL */ `
  query CustomerRequestsByCreatedAt(
    $baseType: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByCreatedAt(
      baseType: $baseType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestsByNumber = /* GraphQL */ `
  query CustomerRequestsByNumber(
    $baseType: String!
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByNumber(
      baseType: $baseType
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestsByCurrentStatus = /* GraphQL */ `
  query CustomerRequestsByCurrentStatus(
    $baseType: String!
    $currentStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByCurrentStatus(
      baseType: $baseType
      currentStatus: $currentStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestsByReference = /* GraphQL */ `
  query CustomerRequestsByReference(
    $baseType: String!
    $reference: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByReference(
      baseType: $baseType
      reference: $reference
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomerRequestItems = /* GraphQL */ `
  query GetCustomerRequestItems($id: ID!) {
    getCustomerRequestItems(id: $id) {
      id
      createdAt
      companyID
      contactPersonID
      title
      description
      customerArticleNumber
      quantity {
        value
        unit
      }
      targetPrice {
        currency
        value
      }
      material
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      width {
        value
        unit
      }
      length {
        value
        unit
      }
      height {
        value
        unit
      }
      itemsID
      notes
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      customerRequestsID
      customerRequest {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const listCustomerRequestItems = /* GraphQL */ `
  query ListCustomerRequestItems(
    $filter: ModelCustomerRequestItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerRequestItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        companyID
        contactPersonID
        title
        description
        customerArticleNumber
        quantity {
          value
          unit
        }
        targetPrice {
          currency
          value
        }
        material
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        itemsID
        notes
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        customerRequestsID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestItemsByTitle = /* GraphQL */ `
  query CustomerRequestItemsByTitle(
    $baseType: String!
    $title: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestItemsByTitle(
      baseType: $baseType
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        companyID
        contactPersonID
        title
        description
        customerArticleNumber
        quantity {
          value
          unit
        }
        targetPrice {
          currency
          value
        }
        material
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        itemsID
        notes
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        customerRequestsID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerRequestItemsByCustomerArticleNumber = /* GraphQL */ `
  query CustomerRequestItemsByCustomerArticleNumber(
    $baseType: String!
    $customerArticleNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestItemsByCustomerArticleNumber(
      baseType: $baseType
      customerArticleNumber: $customerArticleNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        companyID
        contactPersonID
        title
        description
        customerArticleNumber
        quantity {
          value
          unit
        }
        targetPrice {
          currency
          value
        }
        material
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        itemsID
        notes
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        customerRequestsID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSalesOffer = /* GraphQL */ `
  query GetSalesOffer($id: ID!) {
    getSalesOffer(id: $id) {
      id
      customerRequestID
      customerRequest {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      acceptedByUserID
      createdAt
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      netSum {
        currency
        value
      }
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      deliveryTime
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      offerItems {
        items {
          id
          salesOffersID
          salesOffer {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          companyID
          createdAt
          title
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity {
            value
            unit
          }
          price {
            currency
            value
          }
          discount
          vat
          optional
          toolCosts {
            currency
            value
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          editable
          selected
          serviceTemplate
          updatedAt
        }
        nextToken
      }
      itemsSelectable
      deliveryCosts {
        currency
        value
      }
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      updatedAt
    }
  }
`;
export const listSalesOffers = /* GraphQL */ `
  query ListSalesOffers(
    $filter: ModelSalesOfferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSalesOffers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerRequestID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        acceptedByUserID
        createdAt
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        contactPersonID
        decimalPlaces
        number
        productRequestsID
        paymentConditions
        deliveryConditions
        netSum {
          currency
          value
        }
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        deliveryTime
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        offerItems {
          items {
            id
            salesOffersID
            salesOffer {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            companyID
            createdAt
            title
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity {
              value
              unit
            }
            price {
              currency
              value
            }
            discount
            vat
            optional
            toolCosts {
              currency
              value
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            editable
            selected
            serviceTemplate
            updatedAt
          }
          nextToken
        }
        itemsSelectable
        deliveryCosts {
          currency
          value
        }
        deliveryVat
        declineReason
        declineComment
        internalComment
        externalComment
        customerReference
        status
        validUntil
        sentExpiringReminder
        updatedAt
      }
      nextToken
    }
  }
`;
export const salesOfferByStatus = /* GraphQL */ `
  query SalesOfferByStatus(
    $status: String!
    $validUntil: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSalesOfferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    salesOfferByStatus(
      status: $status
      validUntil: $validUntil
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerRequestID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        acceptedByUserID
        createdAt
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        contactPersonID
        decimalPlaces
        number
        productRequestsID
        paymentConditions
        deliveryConditions
        netSum {
          currency
          value
        }
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        deliveryTime
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        offerItems {
          items {
            id
            salesOffersID
            salesOffer {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            companyID
            createdAt
            title
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity {
              value
              unit
            }
            price {
              currency
              value
            }
            discount
            vat
            optional
            toolCosts {
              currency
              value
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            editable
            selected
            serviceTemplate
            updatedAt
          }
          nextToken
        }
        itemsSelectable
        deliveryCosts {
          currency
          value
        }
        deliveryVat
        declineReason
        declineComment
        internalComment
        externalComment
        customerReference
        status
        validUntil
        sentExpiringReminder
        updatedAt
      }
      nextToken
    }
  }
`;
export const salesOfferBySentExpiringReminder = /* GraphQL */ `
  query SalesOfferBySentExpiringReminder(
    $sentExpiringReminder: String!
    $validUntil: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSalesOfferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    salesOfferBySentExpiringReminder(
      sentExpiringReminder: $sentExpiringReminder
      validUntil: $validUntil
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerRequestID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        acceptedByUserID
        createdAt
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        contactPersonID
        decimalPlaces
        number
        productRequestsID
        paymentConditions
        deliveryConditions
        netSum {
          currency
          value
        }
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        deliveryTime
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        offerItems {
          items {
            id
            salesOffersID
            salesOffer {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            companyID
            createdAt
            title
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity {
              value
              unit
            }
            price {
              currency
              value
            }
            discount
            vat
            optional
            toolCosts {
              currency
              value
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            editable
            selected
            serviceTemplate
            updatedAt
          }
          nextToken
        }
        itemsSelectable
        deliveryCosts {
          currency
          value
        }
        deliveryVat
        declineReason
        declineComment
        internalComment
        externalComment
        customerReference
        status
        validUntil
        sentExpiringReminder
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSalesOfferItems = /* GraphQL */ `
  query GetSalesOfferItems($id: ID!) {
    getSalesOfferItems(id: $id) {
      id
      salesOffersID
      salesOffer {
        id
        customerRequestID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        acceptedByUserID
        createdAt
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        contactPersonID
        decimalPlaces
        number
        productRequestsID
        paymentConditions
        deliveryConditions
        netSum {
          currency
          value
        }
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        deliveryTime
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        offerItems {
          items {
            id
            salesOffersID
            salesOffer {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            companyID
            createdAt
            title
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity {
              value
              unit
            }
            price {
              currency
              value
            }
            discount
            vat
            optional
            toolCosts {
              currency
              value
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            editable
            selected
            serviceTemplate
            updatedAt
          }
          nextToken
        }
        itemsSelectable
        deliveryCosts {
          currency
          value
        }
        deliveryVat
        declineReason
        declineComment
        internalComment
        externalComment
        customerReference
        status
        validUntil
        sentExpiringReminder
        updatedAt
      }
      companyID
      createdAt
      title
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      quantity {
        value
        unit
      }
      price {
        currency
        value
      }
      discount
      vat
      optional
      toolCosts {
        currency
        value
      }
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      editable
      selected
      serviceTemplate
      updatedAt
    }
  }
`;
export const listSalesOfferItems = /* GraphQL */ `
  query ListSalesOfferItems(
    $filter: ModelSalesOfferItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSalesOfferItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        salesOffersID
        salesOffer {
          id
          customerRequestID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          acceptedByUserID
          createdAt
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          contactPersonID
          decimalPlaces
          number
          productRequestsID
          paymentConditions
          deliveryConditions
          netSum {
            currency
            value
          }
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          deliveryTime
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          offerItems {
            items {
              id
              salesOffersID
              salesOffer {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              companyID
              createdAt
              title
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity {
                value
                unit
              }
              price {
                currency
                value
              }
              discount
              vat
              optional
              toolCosts {
                currency
                value
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              editable
              selected
              serviceTemplate
              updatedAt
            }
            nextToken
          }
          itemsSelectable
          deliveryCosts {
            currency
            value
          }
          deliveryVat
          declineReason
          declineComment
          internalComment
          externalComment
          customerReference
          status
          validUntil
          sentExpiringReminder
          updatedAt
        }
        companyID
        createdAt
        title
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        quantity {
          value
          unit
        }
        price {
          currency
          value
        }
        discount
        vat
        optional
        toolCosts {
          currency
          value
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        editable
        selected
        serviceTemplate
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCommunicationMessages = /* GraphQL */ `
  query GetCommunicationMessages($id: ID!) {
    getCommunicationMessages(id: $id) {
      id
      countries
      companyID
      userID
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      user {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      messageUser {
        firstName
        lastName
      }
      objectID
      objectType
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      content
      reactions {
        users {
          firstName
          lastName
        }
        reaction
      }
      mentionedUsers {
        firstName
        lastName
      }
    }
  }
`;
export const listCommunicationMessages = /* GraphQL */ `
  query ListCommunicationMessages(
    $filter: ModelCommunicationMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunicationMessages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        countries
        companyID
        userID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        messageUser {
          firstName
          lastName
        }
        objectID
        objectType
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        content
        reactions {
          users {
            firstName
            lastName
          }
          reaction
        }
        mentionedUsers {
          firstName
          lastName
        }
      }
      nextToken
    }
  }
`;
export const communicationMessagesByObjectId = /* GraphQL */ `
  query CommunicationMessagesByObjectId(
    $objectID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommunicationMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    communicationMessagesByObjectId(
      objectID: $objectID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        countries
        companyID
        userID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        messageUser {
          firstName
          lastName
        }
        objectID
        objectType
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        content
        reactions {
          users {
            firstName
            lastName
          }
          reaction
        }
        mentionedUsers {
          firstName
          lastName
        }
      }
      nextToken
    }
  }
`;
export const getHsCodes = /* GraphQL */ `
  query GetHsCodes($id: ID!) {
    getHsCodes(id: $id) {
      id
      goodsCode
      goodsCodeCN
      duty
      duties {
        goodsCode
        goodsCodeCN
        addCode
        orderNo
        startDate
        endDate
        redInd
        origin
        measureType
        legalBase
        duty
        originCode
        measTypeCode
      }
      createdAt
      updatedAt
    }
  }
`;
export const listHsCodes = /* GraphQL */ `
  query ListHsCodes(
    $filter: ModelHsCodesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHsCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getQualityReports = /* GraphQL */ `
  query GetQualityReports($id: ID!) {
    getQualityReports(id: $id) {
      id
      purchaseOrderItemsID
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      countries
      maxQuantityItemsToCheck
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      qualityReportItems {
        items {
          id
          countries
          qualityReportID
          testedItems
          createdAt
          updatedAt
        }
        nextToken
      }
      finalStatus
      finishedDate
      createdAt
      updatedAt
      baseType
    }
  }
`;
export const listQualityReports = /* GraphQL */ `
  query ListQualityReports(
    $filter: ModelQualityReportsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQualityReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        purchaseOrderItemsID
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        countries
        maxQuantityItemsToCheck
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        qualityReportItems {
          items {
            id
            countries
            qualityReportID
            testedItems
            createdAt
            updatedAt
          }
          nextToken
        }
        finalStatus
        finishedDate
        createdAt
        updatedAt
        baseType
      }
      nextToken
    }
  }
`;
export const qualityReportsByCreatedAt = /* GraphQL */ `
  query QualityReportsByCreatedAt(
    $baseType: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQualityReportsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    qualityReportsByCreatedAt(
      baseType: $baseType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        purchaseOrderItemsID
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        countries
        maxQuantityItemsToCheck
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        qualityReportItems {
          items {
            id
            countries
            qualityReportID
            testedItems
            createdAt
            updatedAt
          }
          nextToken
        }
        finalStatus
        finishedDate
        createdAt
        updatedAt
        baseType
      }
      nextToken
    }
  }
`;
export const qualityReportsByFinalStatus = /* GraphQL */ `
  query QualityReportsByFinalStatus(
    $baseType: String!
    $finalStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQualityReportsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    qualityReportsByFinalStatus(
      baseType: $baseType
      finalStatus: $finalStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        purchaseOrderItemsID
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        countries
        maxQuantityItemsToCheck
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        qualityReportItems {
          items {
            id
            countries
            qualityReportID
            testedItems
            createdAt
            updatedAt
          }
          nextToken
        }
        finalStatus
        finishedDate
        createdAt
        updatedAt
        baseType
      }
      nextToken
    }
  }
`;
export const qualityReportsByFinishedDate = /* GraphQL */ `
  query QualityReportsByFinishedDate(
    $baseType: String!
    $finishedDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQualityReportsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    qualityReportsByFinishedDate(
      baseType: $baseType
      finishedDate: $finishedDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        purchaseOrderItemsID
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        countries
        maxQuantityItemsToCheck
        itemsID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        qualityReportItems {
          items {
            id
            countries
            qualityReportID
            testedItems
            createdAt
            updatedAt
          }
          nextToken
        }
        finalStatus
        finishedDate
        createdAt
        updatedAt
        baseType
      }
      nextToken
    }
  }
`;
export const getQualityReportItems = /* GraphQL */ `
  query GetQualityReportItems($id: ID!) {
    getQualityReportItems(id: $id) {
      id
      countries
      qualityReportID
      testedItems
      createdAt
      updatedAt
    }
  }
`;
export const listQualityReportItems = /* GraphQL */ `
  query ListQualityReportItems(
    $filter: ModelQualityReportItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQualityReportItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        countries
        qualityReportID
        testedItems
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const qualityReportItemsByQualityReportID = /* GraphQL */ `
  query QualityReportItemsByQualityReportID(
    $qualityReportID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQualityReportItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    qualityReportItemsByQualityReportID(
      qualityReportID: $qualityReportID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        countries
        qualityReportID
        testedItems
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompaniesProductRequests = /* GraphQL */ `
  query GetCompaniesProductRequests($id: ID!) {
    getCompaniesProductRequests(id: $id) {
      id
      companiesID
      productRequestsID
      companies {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      productRequests {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      createdAt
      updatedAt
      contactPersonUserId
      countryCode
      involvedUsersIds
    }
  }
`;
export const listCompaniesProductRequests = /* GraphQL */ `
  query ListCompaniesProductRequests(
    $filter: ModelCompaniesProductRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompaniesProductRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companiesID
        productRequestsID
        companies {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        productRequests {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        createdAt
        updatedAt
        contactPersonUserId
        countryCode
        involvedUsersIds
      }
      nextToken
    }
  }
`;
export const shipmentMap = /* GraphQL */ `
  query ShipmentMap {
    shipmentMap {
      position
      orders {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      positionNumber
      eta
      id
    }
  }
`;
export const shipmentSustainabilityImpact = /* GraphQL */ `
  query ShipmentSustainabilityImpact($id: ID!) {
    shipmentSustainabilityImpact(id: $id) {
      type
      from
      to
      distance
      totalCargoWeight {
        value
        unit
      }
      ewWellToWheel
      gwWellToWheel
      etTankToWheel
      gtTankToWheel
    }
  }
`;
export const orderSustainabilityImpact = /* GraphQL */ `
  query OrderSustainabilityImpact($id: ID!) {
    orderSustainabilityImpact(id: $id) {
      type
      from
      to
      distance
      totalCargoWeight {
        value
        unit
      }
      ewWellToWheel
      gwWellToWheel
      etTankToWheel
      gtTankToWheel
    }
  }
`;
export const itemsSearch = /* GraphQL */ `
  query ItemsSearch($searchValue: String, $companyID: String) {
    itemsSearch(searchValue: $searchValue, companyID: $companyID) {
      id
      translations {
        id
        createdAt
        languageCode
        companyIDs
        field
        translation
        translationSearch
        collectionName
        objectID
        item {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        updatedAt
      }
      number
      customerArticleNumber
      material
      weight {
        value
        unit
      }
      itemsHeadID
      coverImageId
    }
  }
`;
export const customListContactPersons = /* GraphQL */ `
  query CustomListContactPersons(
    $type: String
    $country: String
    $funnel: String
  ) {
    customListContactPersons(type: $type, country: $country, funnel: $funnel) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      hubspotId
      countries
      type
      funnel
    }
  }
`;
export const customGetContactPerson = /* GraphQL */ `
  query CustomGetContactPerson($id: ID!) {
    customGetContactPerson(id: $id) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      hubspotId
      countries
      type
      funnel
    }
  }
`;
